var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.error != null)?_c('div',{attrs:{"id":"error-container"}},[_c('p',[_c('i',{staticClass:"fa fa-warning"}),_vm._v(" "+_vm._s(_vm.error.message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }